import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};
export const PageFooter = ({ children }: Props) => {
  return <div>{children}</div>;
};
